import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { cn } from "@omni/utils/styles";

import {
    AmountDropDownComponent,
    AmountDropDownComponentProps
} from "./components/amountDropDown.component";
import {
    AmountInputComponent,
    AmountInputComponentProps
} from "./components/amountInput.component";

type AmountProps = AmountDropDownComponentProps &
    AmountInputComponentProps & {
        className?: string;
    };

const Amount = ({
    roundingValue,
    activeDelivery,
    isUpdatingCart,
    minimumOrderQuantity,
    onQuantityChange,
    value,
    hasProductMultipleCartEntries,
    isFree,
    isFreeEntryAddedByCustomer,
    className
}: AmountProps) => {
    if (
        roundingValue === 1 ||
        activeDelivery === DeliveryType.ClickAndCollect
    ) {
        return (
            <AmountInputComponent
                activeDelivery={activeDelivery}
                isUpdatingCart={isUpdatingCart}
                minimumOrderQuantity={minimumOrderQuantity}
                onQuantityChange={onQuantityChange}
                roundingValue={roundingValue}
                className={cn(className)}
                value={value}
                hasProductMultipleCartEntries={hasProductMultipleCartEntries}
                isFree={isFree}
                isFreeEntryAddedByCustomer={isFreeEntryAddedByCustomer}
            />
        );
    } else {
        return (
            <AmountDropDownComponent
                isUpdatingCart={isUpdatingCart}
                minimumOrderQuantity={minimumOrderQuantity}
                onQuantityChange={onQuantityChange}
                roundingValue={roundingValue}
                value={value}
                className={cn(className)}
            />
        );
    }
};

export { Amount };
